import { authHeader } from '../helpers/auth-header';
import { config } from '../helpers/config';
import { commonServices } from './common.service';


export const services = {
    getRoles,
    update,
    delete: _delete,
    register,
};

function getRoles() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    console.log('getRoles');

    return fetch(config.apiUrl + '/api/account/roles', requestOptions)
    .then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));

}

function register(role) {
    const requestOptions = {
        method: 'POST',
        headers: {
            ...authHeader(),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(role)
    };

    return fetch(config.apiUrl + '/api/account/roles', requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}


function update(role) {
    const requestOptions = {
        method: 'PUT',
        headers: {
            ...authHeader(),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(role)
    };

    return fetch(config.apiUrl + '/api/account/roles/' + role.id, requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}

// prefixed function name with underscore because delete is a reserved word in
// javascript
function _delete(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    // return fetch(config.apiUrl + '/api/account/roles/' + id, requestOptions).then(
    //     response => commonServices.handleResponse(response), 
    //     error => commonServices.handleError(error));

    return fetch(config.apiUrl + '/api/account/roles/' + id, requestOptions).then(commonServices.handleResponse);
}




// WEBPACK FOOTER //
// ./src/services/roles.service.js